import { format, isValid, parse, parseISO } from 'date-fns';
import { dateFormats } from './constants';

export const money = (value, defaultValue = '-') => {
  if (!value) return '0.00';
  else if (!/^[0-9]+(\.[0-9]+)?$/.test(value)) return defaultValue;
  let roundedValue = parseFloat(Math.abs(value).toString()).toFixed(2);
  let pieces = roundedValue.split('.');

  let dollars = '';
  for (let i = pieces[0].length - 1; i > 0; i--) {
    dollars =
      (pieces[0].length - i) % 3 === 0 && i != pieces[0].length - 1
        ? `,${pieces[0].substring(i, i + 1)}${dollars}`
        : `${pieces[0].substring(i, i + 1)}${dollars}`;
  }
  return `${value < 0 ? '-' : ''}${pieces[0].substring(0, 1)}${dollars}.${
    pieces[1]
  }`;
};

export function moneyV2(amount) {
  // Convert the amount to a number, handling potential strings
  const numberAmount = parseFloat(amount);

  // Check if the amount is NaN (Not a Number)
  if (isNaN(numberAmount)) {
    return "Invalid amount";
  }

  // Format the number with commas and two decimal places
  const formattedAmount = numberAmount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  return formattedAmount;
}
export const toInputDate = date => {
  if (!date || !date.match(/^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/)) return '';
  else {
    let pieces = date.split('/');
    return `${pieces[2]}-${pieces[0]}-${pieces[1]}`;
  }
};
export const toStandardDate = date => {
  if (!date || !date.match(/^[0-9]{4}\-[0-9]{2}\-[0-9]{2}$/)) return '';
  else {
    let pieces = date.split('-');
    return `${pieces[1]}/${pieces[2]}/${pieces[0]}`;
  }
};
export const moneyToNumber = value => {
  return value
    ? Math.abs(
        parseFloat(
          value
            .toString()
            .replace('$', '')
            .replace('%', '')
            .replace(new RegExp(',', 'g'), '')
            .replace(new RegExp(':', 'g'), '')
        )
      )
    : 0;
};
export const normalizeValue = value => {
  return value ? value.replace(new RegExp('[^a-zA-Z0-9.]', 'g'), '') : '';
};

export const schedule = schedule => {
  switch (schedule) {
    case 7:
      return 'Weekly';
    case 14:
      return 'Bi-Weekly';
    case 15:
      return 'Semi-Monthly';
    case 30:
      return 'Monthly';
    case 365:
      return 'Yearly';
    case 90:
      return 'Quarterly';
    case 180:
      return 'Semi-Annual';
    default:
      return '';
  }
};

export const repaymentPlanText = plan => {
  plan = plan && parseInt(plan.toString());
  switch (plan) {
    case 0:
      return 'STANDARD';
    case 1:
      return 'GRADUATED';
    case 2:
      return 'EXTENDED GRADUATED';
    case 3:
      return 'EXTENDED FIXED';
    case 4:
      return 'PAY AS YOU EARN';
    case 5:
      return 'SAVE';
    case 6:
      return 'INCOME BASED REPAYMENT';
    case 7:
      return 'INCOME CONTINGENT REPAYMENT';
    case 8:
      return 'REFINANCING';
    case 9:
      return 'OTHER';
    case 11:
      return 'EXTENDED REPAYMENT';
    case 12:
      return 'RAP';
    default:
      return 'SAME AS CURRENT';
  }
};
export const repaymentPlanCode = plan => {
  if (plan) {
    plan = plan.toUpperCase().replace(/[^A-Z\s]/gi, ' ');
    if (plan.indexOf('STANDARD') >= 0) return 0;
    else if (plan.indexOf('EXTENDED') >= 0 && plan.indexOf('GRADUATED') >= 0)
      return 2;
    else if (plan.indexOf('GRADUATED') >= 0) return 1;
    else if (plan.indexOf('FIXED') >= 0 || plan.indexOf('EXTENDED') >= 0)
      return 3;
    else if (plan.indexOf('REVISED') >= 0 || plan.indexOf('REPAYE') >= 0 || plan.indexOf('SAVE') >= 0)
      return 5;
    else if (plan.indexOf('PAY AS YOU EARN') >= 0 || plan.indexOf('PAYE') >= 0)
      return 4;
    else if (
      (plan.indexOf('INCOME') >= 0 && plan.indexOf('BASED')) ||
      plan.indexOf('IBR') >= 0
    )
      return 6;
    else if (
      (plan.indexOf('INCOME') >= 0 && plan.indexOf('CONTINGENT')) ||
      plan.indexOf('ICR') >= 0
    )
      return 7;
    else if (plan.indexOf('REFINANCING') >= 0) return 8;
    else return 9;
  }
};
export const normalizeMyStudentData = myStudentData => {
  if (!myStudentData || !myStudentData.student_loans)
    return {
      student_loans: [],
      analysis: false
    };
  let idCount = 0;
  let id = Date.now();
  return {
    ...myStudentData,
    student_loans: myStudentData.student_loans.map((loan, index) => {
      if (!loan.id) {
        loan.id = `${id}${idCount}`;
        idCount++;
      }
      loan.loans = loan.loans.map(subloan => {
        if (!subloan.loan_id) {
          subloan.loan_id = `${id}${idCount}`;
          idCount++;
        }
        return subloan;
      });
      return loan;
    })
  };
};
export const statusText = status => {
  status = parseInt(status.toString());
  switch (status) {
    case 0:
      return 'IN REPAYMENT';
    case 1:
      return 'DEFERRED';
    case 2:
      return 'FORBEARANCE';
    case 3:
      return 'BANKRUPT';
    case 4:
      return 'CANCELED';
    case 5:
      return 'DEFAULTED';
    case 6:
      return 'GRACE';
    case 7:
      return 'PAID';
    default:
      return 'OTHER';
  }
};
export const statusCode = status => {
  status = parseInt(status.toString());
  switch (status) {
    case 0:
      return 'RP';
    case 1:
      return 'DA';
    case 2:
      return 'FB';
    case 3:
      return 'BK';
    case 4:
      return 'CA';
    case 5:
      return 'DF';
    case 6:
      return 'IG';
    case 7:
      return 'PF';
    default:
      return 'OTHER';
  }
};
export const getServicerName = (loanId, myStudentData) => {
  let loanData = null;
  myStudentData.student_loans.forEach(loan => {
    if (!loanData)
      loanData = loan.loans.find(studentLoan => studentLoan.id == loanId);
  });
  if (loanData) {
    let servicer = loanData.loan_contact;
    return servicer ? servicer.loan_contact_name : '';
  }
  return '';
};

export const getServicerFromId = (servicerId, myStudentData, servicers) => {
  let servicer 
  if (myStudentData) {
   servicer = myStudentData.student_loans.reduce((servicer, loan) => {
    let servicerName = loan.loans.reduce((servicerName, loanInfo) => {
      let servicerData
      if ((loanInfo.loan_contact || {}).id === servicerId) {
        servicerData = loanInfo.loan_contact;
      }
      if (servicerData) return servicerData.loan_contact_name;
      else return servicerName;
    }, '');
    if (servicerName) return servicerName;
    else return servicer;
  }, '');
  if (!servicer) {
    const s = servicers.find(serv => serv.id === servicerId);
    if (s) {
      servicer = s.name;
    }
  }
  return servicer;
  }
};

export const getServicersList = myStudentData => {
  let servicers = [];
  myStudentData.student_loans.forEach(loan => {
    loan.loans
      .filter((loan) => moneyToNumber(loan.loan_outstanding_principal_balance) > 0)
      .forEach(loanInfo => {
        const servicer = loanInfo.loan_contact
        if (servicer && !servicers.find(includedServicer => includedServicer.id == servicer.id)) {
          servicers.push({
            id: servicer.id,
            servicer: servicer.loan_contact_name
          });
        }
      });
  });
  return servicers;
};



export const getServicer = (id, myStudentData) => {
  if (id === 'fedloan') {
    return 'FedLoan';
  }
  return myStudentData.student_loans.reduce((servicer, loan) => {
    if (!servicer)
      return loan.loans.reduce((loanServicer, loanInfo) => {
        if (loanServicer) return loanServicer;
        return loanInfo.loan_contact;
      }, null);
    else return servicer;
  }, null);
};

export const codeStatus = status => {
  if (status == 'DA') return 1;
  else if (status.substring(0, 1) == 'D') return 5;
  else if (status.substring(0, 1) == 'I') return 6;
  else if (status.substring(0, 1) == 'P') return 7;
  switch (status) {
    case 'RP':
      return 0;
    case 'DA':
      return 1;
    case 'FB':
      return 2;
    case 'BK':
    case 'BC':
      return 3;
    case 'CA':
    case 'CS':
      return 4;
    case 'DF':
      return 5;
    case 'IG':
      return 6;
    case 'PF':
      return 7;
    default:
      return 8;
  }
};
export const getDefaultServicerForForm = form => {
  if (form.servicer === 'fedloan') {
    return 'FedLoan';
  }
  switch (parseInt(form)) {
    case 2:
    case 3:
      return 'Dept. of Ed.';
    case 12:
      return 'American Education Services (AES)';
    case 13:
      return 'Navient';
    case 14:
      return 'FedLoan';
    case 15:
      return 'Great Lakes';
    case 16:
      return 'NelNet';
    case 17:
      return 'OSLA';
    case 18:
      return 'Granite State';
    case 22:
      return 'ED Financial Services';
    default:
      return '';
  }
};

export const getGovernmentFormName = (form, recertification = false) => {
  switch (parseInt(form)) {
    case 0:
      return `Income Driven Repayment Plan ${
        recertification ? 'Recertification' : 'Request'
      }`;
    case 1:
      return 'Direct Consolidation Loan Application';
    case 2:
      return 'PSLF Application';
    case 3:
      return 'PSLF Employment Certification';
    case 4:
      return 'Teacher Loan Forgiveness Application';
    case 5:
      return 'Letter to Verify Income';
    case 6:
      return 'Third Party Servicer Authorization';
    case 7:
      return 'Perkins Loan Deferment Request';
    case 8:
      return 'Perkins Loan Cancelation Application';
    case 9:
      return 'Last Year Tax Return';
    case 10:
      return 'Most Recent Paystub';
    case 11:
      return 'Repayment Plan Request';
    case 12:
      return '3rd party authorization for American Education Services';
    case 13:
      return '3rd party authorization for Navient';
    case 14:
      return '3rd party authorization for FedLoan';
    case 15:
      return '3rd party authorization for Great Lakes';
    case 16:
      return '3rd party authorization for NelNet';
    case 17:
      return '3rd party authorization for OSLA';
    case 18:
      return '3rd party authorization for Granite State';
    case 19:
      return "Spouse's Last Year Tax Return";
    case 20:
      return 'Income Driven Repayment Plan Annual Recertification';
    case 21:
      return "Spouse's Most Recent Paystubs";
    case 22:
      return '3rd party authorization for ED Financial';
    case 23:
      return 'Generic 3rd party authorization';
    case 24:
      return 'Supporting Document - ';
    default:
      return 'Unknown';
  }
};

export const printName = name => {
  const nameParts = name.split(' ');
  return nameParts
    .map(namePart =>
      namePart
        ? `${namePart[0].toUpperCase()}${namePart.substring(1).toLowerCase()}`
        : ''
    )
    .join(' ');
};
export const printFilingStatus = status => {
  switch (status) {
    case 'single':
      return 'Single or Head of Household';
    case 'married-jointly':
      return 'Married Filing Jointly';
    case 'married-separately':
      return 'Married Filing Separately';
    case 'married-separated':
      return 'Married but separated';
    case 'household-head':
      return "Married, but cannot reasonably access my spouse's income information";
    default:
      return 'Unknown';
  }
};
export const printMaxCharacters = (text, characters = 100) => {
  if ((text && text.length) > characters) {
    return `${text.substring(0, characters - 3)}...`;
  }
  return text;
};
export const getLoanServicerMailingAddress = LoanServicer => {
  switch (LoanServicer) {
    case 0:
      return {
        name: 'MOHELA',
        address: '633 Spirit Drive',
        city: 'Chesterfield',
        state: 'MO',
        zip: '63005-1243',
        fax: '866-222-7060',
        phone: '888-866-4352',
        email: ''
      };
    case 1:
      return {
        name: 'Granite State Management & Resources',
        address: 'P.O. Box 3420',
        city: 'Concord',
        state: 'NH',
        zip: '03302-3420',
        fax: '603-227-5415',
        phone: '888-556-0022',
        email: ''
      };
    case 2:
      return {
        name: 'CornerStone Education Loan Services',
        address: 'P.O. Box 145122',
        city: 'Salt Lake City',
        state: 'UT',
        zip: '84114-5122',
        fax: '801-366-8400',
        phone: '800-663-1662',
        email: 'customerservice@mycornerstoneloan.org'
      };
    case 3:
      return {
        name: 'OSLA Customer Service',
        address: 'P.O. Box 18145',
        city: 'Oklahoma City',
        state: 'OK',
        zip: '73154-0145',
        fax: '405-556-9255',
        phone: '405-556-9200',
        email: ''
      };
    case 4:
      return {
        name: 'Navient – U.S. Dep of Ed Loan Servicing',
        address: 'P.O. Box 9760',
        city: 'Wilkes-Barre',
        state: 'PA',
        zip: '18773-9760',
        fax: '866-266-0178',
        phone: '800-722-1300',
        email: ''
      };
    case 5:
      return {
        name: 'AES',
        address: 'P.O. Box 2461',
        city: 'Harrisburg',
        state: 'PA',
        zip: '17105-2461',
        fax: '717-720-3916',
        phone: '',
        email: ''
      };
    case 6:
      return {
        name: 'FedLoan Servicing',
        address: 'P.O. Box 69184',
        city: 'Harrisburg',
        state: 'PA',
        zip: '17106-9184',
        fax: '717-720-1628',
        phone: '',
        email: ''
      };
    case 7:
      return {
        name: 'Great Lakes',
        address: 'PO Box 7860',
        city: 'Madison',
        state: 'WI',
        zip: '53707-7860',
        fax: '608-246-1608',
        phone: '',
        email: ''
      };
    case 8:
      return {
        name: 'Nelnet',
        address: 'P.O. Box 82658',
        city: 'Lincoln',
        state: 'NE',
        zip: '68501-2658',
        fax: '',
        phone: '1-866-426-6765',
        email: 'WrittenRequest@nelnet.net'
      };
    case 11:
      return {
        name: 'EDFINANCIAL SERVICES',
        address: 'P.O. BOX 36008',
        city: 'Knoxville',
        state: 'TN',
        zip: '37930-6008',
        fax: '865-692-6348',
        phone: '865-692-6349',
        email: ''
      };
    default:
      return null;
  }
};

export const getNoOfDays = (value) => {
  const today = new Date();
  const date = new Date(value)
  const diff = today.getTime() - date.getTime();
  return Math.round(diff / (1000 * 3600 * 24));
}

export const flattenLoansByType = (msdDetails) => {
  return msdDetails.student_loans.flatMap(studentLoanType =>
    studentLoanType.loans.map(loan => ({ loan_type: studentLoanType.loan_type, ...loan })));
}

export const sortArrayByKey = (data, sortBy) => {
  return data.sort((loanA, loanB) => {
    const aLoan = moneyToNumber(loanA[sortBy]);
    const bLoan = moneyToNumber(loanB[sortBy]);
    return bLoan - aLoan;
  });
}

export const extractFileLastName = (filename, prefix) => {
  const pattern = new RegExp(`^${prefix}\\d+_`);
  const resultString = filename.replace(pattern, "");
  if (resultString.length > 23) {
    return resultString.slice(-23);
  }
  return resultString;
}

export const getFileName = (form, extension) => {
  switch (form) {
    case 1:
      return 'Direct_Consolidation_Loan_Application_and_Promissory_Note.pdf';
    case 0:
      return 'Income_Driven_Repayment_Plan_Request.pdf';
    case 2:
      return 'PUBLIC_SERVICE_LOAN_FORGIVENESS_APPLICATION_FOR_FORGIVENESS.pdf';
    case 3:
      return 'PUBLIC_SERVICE_LOAN_FORGIVENESS_EMPLOYMENT_CERTIFICATION_FORM.pdf';
    case 11:
      return 'Repayment-Plan-Request.pdf';
    case 4:
      return 'TEACHER_LOAN_FORGIVENESS_APPLICATION.pdf';
    case 5:
      return 'LETTER_TO_VERIFY_INCOME.pdf';
    case 6:
      return 'THIRD_PARTY_SERVICER_AUTHORIZATION.pdf';
    case 7:
      return 'PERKINS_LOAN_DEFERREMENT_APPLICATION.pdf';
    case 8:
      return 'PERKINS_LOAN_CANCELLATION_APPLICATION.pdf';
    case 9:
      return 'LAST_YEAR_TAX_RETURNS.pdf';
    case 10:
      return 'THREE_MONTHS_PAYSTUBS.pdf';
    case 12:
      return 'THIRD_PARTY_AES.pdf';
    case 13:
      return 'THIRD_PARTY_NAVIENT.pdf';
    case 14:
      return 'THIRD_PARTY_FEDLOAN.pdf';
    case 15:
      return 'THIRD_PARTY_GREAT_LAKES.pdf';
    default:
      return `form.${extension}`;
  }
}

export const getEmployerAddressFromObject = (employerAddress) => {
  return `${employerAddress.street.replace(",", "")}, ${employerAddress.city}, ${employerAddress.state} ${employerAddress.zip}`;
}
export const getEmployerAddressObjectFromString = (employerAddress) => {
  const [street, city, stateZip] = employerAddress.split(",");
  const [state, zip] = stateZip.match(/(\S+)\s+(\S+)/).slice(1, 3);
  return {
          street: street.trim() || "",
          city: city.trim() || "",
          state: state.trim() || "",
          zip: zip.trim() || "",
    };
}

export const STATES = {
  AL: "Alabama",
  AK: "Alaska",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "District Of Columbia",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
  PR: "Puerto Rico",
};

export const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});

export const formatDoh = (each, dateFormat) => {
  let normalizedDoh = each.doh;

  normalizedDoh = normalizedDoh
    .replace(/ (\d):/, ' 0$1:')
    .replace(/(-\d{2}:\d{2})$/, 'T00:00:00$1');

  const parsedDate = parse(normalizedDoh, dateFormat, new Date());

  if (isValid(parsedDate)) {
    return format(parsedDate, 'MM/dd/yyyy');
  } else {
    const parsedISODate = parseISO(normalizedDoh);
    if (isValid(parsedISODate)) {
      return format(parsedISODate, 'MM/dd/yyyy');
    }
  }
  return each.doh;
};

export const formatTimeType =(each) => {
  const timeType = each.time_type.toLowerCase();
  if(timeType.startsWith("p")){
    return "PT" 
  } 
  if(timeType.startsWith("f")){
    return "FT"
  }
  const weeklyHours = each.weekly_hours;
  if(timeType !== "" ){
    if(Number(weeklyHours) > 30){
      return "FT"
    }
    return "PT" 
  }
  return ""

}

export const formatWeeklyHours = (weeklyhours) => {
  if(!weeklyhours) return weeklyhours;
  const num = parseFloat(weeklyhours);
  return num % 1 === 0 ? `${parseInt(num)}` : num.toFixed(2);
};

export const getDohFormat = (date) => {
  const normalizedDoh = date
    .replace(/ (\d):/, ' 0$1:')
    .replace(/(-\d{2}:\d{2})$/, 'T00:00:00$1');
  for (const format of dateFormats) {
    const parsedDate = parse(date, format, new Date());
    if (isValid(parsedDate)) {
      const [month, day] = date.split(/[/-]/).map(Number);
      if (format === 'MM/dd/yyyy' && month <= 12) {
        return format;
      }
      if (format === 'dd/MM/yyyy' && day > 12) {
        return format;
      }
    }
  }
  const parsedDate = parseISO(normalizedDoh);
  if (isValid(parsedDate)) {
    return 'yyyy-MM-dd';
  }
  return "MM/dd/yyyy";

}


export default {
  getNoOfDays,
  money,
  schedule,
  normalizeValue,
  moneyToNumber,
  statusText,
  repaymentPlanText,
  toInputDate,
  statusCode,
  codeStatus,
  toStandardDate,
  repaymentPlanCode,
  normalizeMyStudentData,
  getServicerName,
  getGovernmentFormName,
  getServicerFromId,
  getServicersList,
  getServicer,
  getDefaultServicerForForm,
  printName,
  printFilingStatus,
  printMaxCharacters,
  getLoanServicerMailingAddress,
  sortArrayByKey,
  extractFileLastName,
  getFileName,
  getEmployerAddressFromObject,
  getEmployerAddressObjectFromString,
  toBase64,
  moneyV2,
  formatDoh,
  formatTimeType,
  getDohFormat
};
